import styled from 'styled-components';

export const HeavyText = styled.span`
  font-weight: 900;
`;

export const LightItalicText = styled.span`
  font-weight: 300;
  font-style: italic;
`;

export const LightText = styled.span`
  font-weight: 300;
  font-style: normal;
`;

export const PageTitle = styled.div`
  text-align: center;
  font-size: x-large;
  padding: 0.75em 1em 0.5em;
  font-weight: 700;
  background: transparent;
`;

export const LoadingText = styled.p`
  text-align: center;
  font-weight: 700;
  font-style: italic;
  color: #999;
  margin-top: 2rem;
`;

export const SmallFont = styled.span`
  font-size: small;
`;

export const Image = styled.img`
  max-width: 100%;
  display: block;
`;

export const Wrapper = styled.section`
  padding: 0.5em 1em;
`;
